"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnrichAIReducers = void 0;
const catalogs_1 = require("./catalogs");
const createEnrichAIReducers = () => {
    const reducers = {
        catalogs: catalogs_1.catalogsReducer,
    };
    return reducers;
};
exports.createEnrichAIReducers = createEnrichAIReducers;
